module.exports = __webpack_public_path__ + "img/galeria-captores-11.eb437009.png";